import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';

import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { METER_TYPE_ERROR_CODES } from 'config/app-config';
import { actionUrl } from 'config/static-content';
import { TrackedCta } from 'components/direct-sales/select-options/components/TrackedCta';

export const relatedMeterCardTestId = 'relatedMeterCardTestId';
export const relatedMeterCardCtaTestId = 'relatedMeterCardCtaTestId';

const { MeterRelatedException } = METER_TYPE_ERROR_CODES;

type RelatedMeterCardProps = {
  errors: {
    code: typeof METER_TYPE_ERROR_CODES[keyof typeof METER_TYPE_ERROR_CODES];
    keyword: 'Gas' | 'Electricity';
  }[];
  name: string;
};

export const RelatedMeterCard = ({ errors, name }: RelatedMeterCardProps) => {
  const electricityErrors = errors.filter(
    (error) => error.keyword === 'Electricity'
  );
  const isRelatedMeter = electricityErrors.some(
    (error) => error.code === MeterRelatedException
  );
  const shouldShow = !!electricityErrors.length && isRelatedMeter;

  if (!shouldShow) {
    return null;
  }

  return (
    <NsStandout decoration="orange" data-testid={relatedMeterCardTestId}>
      <>
        <h3>We can&apos;t provide you with an electricity quote</h3>
        <p>
          We&apos;re sorry, but we can&apos;t give you a quote for your type of
          electricity meter. We&apos;re on it and hope to have this fixed in the
          next few weeks, so please check back.
        </p>
        <TrackedCta name={name}>
          <NsSecondaryCta
            href={actionUrl.bgHome}
            testId={relatedMeterCardCtaTestId}
          >
            Return to home page
          </NsSecondaryCta>
        </TrackedCta>
      </>
    </NsStandout>
  );
};
